import { PortfolioItemExtended } from 'types/portfolios';

export const isPortfolioItemExtended = (properties: any): properties is PortfolioItemExtended => {
    if (!properties || typeof properties !== 'object') {
        return false;
    }

    return (
        typeof properties.id === 'number' &&
        typeof properties.name === 'string' &&
        typeof properties.ownershipPercentage === 'number' &&
        typeof properties.securityId === 'boolean' &&
        typeof properties.typeId === 'number' &&
        typeof properties.isMaster === 'boolean' &&
        typeof properties.itemType === 'string'
    );
};
